import { DeviceService } from "@/services/device.service";

/**
 * 画面マネジャー
 */
export class WindowManager {
  /**
   * 画面幅変更時コールバック配列
   */
  private changeWidthCallback: ((width: number) => void) | null = null;

  /**
   * 以前の画面幅: 0=3つ前, 1=2つ前, 2=1つ前
   */
  private prevWidths: number[] = [0, 0, 0];

  /**
   * 監視間隔[ms]
   */
  private watchInterval = 60;

  /**
   * コンストラクタ
   */
  constructor(private readonly deviceService: DeviceService) {}

  /**
   * 画面横幅を取得する
   */
  public getActualInnerWidth(): number {
    if (!this.deviceService.isSp() || this.deviceService.getOs() !== "ios") {
      return window.innerWidth;
    }

    if ("visualViewport" in window) {
      return Math.round(
        /* eslint-disable @typescript-eslint/no-explicit-any */
        (window as any).visualViewport.scale * window.innerWidth
      );
    }

    return window.innerWidth;
  }

  /**
   * 画面幅変更監視を開始する
   */
  public startToWatchWidth(callback: (width: number) => void): void {
    const width = this.getActualInnerWidth();
    this.changeWidthCallback = callback;
    this.prevWidths[0] = width;
    this.prevWidths[1] = width;
    this.watchWidth();
  }

  /**
   * 画面幅変更監視を停止する
   */
  public stopToWatchWidth(): void {
    this.changeWidthCallback = null;
  }

  /**
   * 画面幅を監視する
   */
  private watchWidth(): void {
    if (!this.changeWidthCallback) {
      return;
    }

    const currWidth = this.getActualInnerWidth();

    if (
      this.prevWidths[0] !== currWidth &&
      this.prevWidths[1] === currWidth &&
      this.prevWidths[2] === currWidth
    ) {
      this.changeWidthCallback(currWidth);
    }

    this.prevWidths[0] = this.prevWidths[1];
    this.prevWidths[1] = this.prevWidths[2];
    this.prevWidths[2] = currWidth;
    setTimeout(() => {
      this.watchWidth();
    }, this.watchInterval);
  }
}
